import React from 'react';
import SmallCheckBox from '../components/SmallCheckBox/SmallCheckBox';

type SelectableProps = {
  onSelect?: (selectedItem: object | null) => void;
  isSelected?: boolean;
  selectable?: boolean;
};

export function withSelectable<P extends object>(WrappedComponent: React.ComponentType<P>) {
  return function (props: P & SelectableProps) {
    const { selectable = true, ...rest } = props;

    const handleSelect = () => {
      props.onSelect?.(props);
    };

    if (!selectable) {
      return <WrappedComponent {...rest as P} />;
    }

    return (
        <>
            <SmallCheckBox onChange={handleSelect} defaultValue={props.isSelected}/>
            &nbsp;
            <WrappedComponent {...rest as P} />
        </>
    );
  };
}

